import React, { useState } from 'react';
import ReportShare from './ReportShare';

// Drop this beside any list's title:  <ExportButton report={vm.report} />
// `report` is { title, subtitle?, note?, columns, rows, totalsRow? } built in
// the page's hook, so the file always matches what the screen is showing.
export default function ExportButton({ report, label = '⇪ Export', className = 'btn light sm', title = 'Print / Save as PDF or Excel' }) {
  const [open, setOpen] = useState(false);
  if (!report) return null;
  return (
    <>
      <button type="button" className={className} title={title} onClick={() => setOpen(true)}>{label}</button>
      {open && <ReportShare {...report} onClose={() => setOpen(false)} />}
    </>
  );
}
